import { FieldDefinition } from "./fieldDefinitions";

export interface DoctorDto {
  doctorId: number;
  firstName: string;
  lastName: string;
  amka: number;
  medicalLicenseNumber?: string;
  specialtyId: number;
  specialtyDescr?: string;
  email?: string;
  phoneNumber: number;
  mobileNumber?: number;
  memberOfMedicalTeam: boolean;
}

export const doctorKeyId = "doctorId" as const;

// Συνάρτηση που επιστρέφει τα πεδία για τη Φόρμα (συμβατή με το FieldDefinition)
export const doctorFields = (
  specialtyOptions: { value: number | string; label: string }[] = [],
): FieldDefinition[] => [
  {
    name: "lastName",
    label: "Επώνυμο",
    type: "text",
    required: true,
  },
  {
    name: "firstName",
    label: "Όνομα",
    type: "text",
    required: true,
  },

  {
    name: "amka",
    label: "ΑΜΚΑ",
    type: "number",
    required: true,
  },
  {
    name: "medicalLicenseNumber",
    label: "Αριθμός Άδειας / Μητρώου",
    type: "text",
    required: false,
  },
  {
    name: "specialtyId",
    label: "Ειδικότητα",
    type: "select",
    required: true,
    options: specialtyOptions,
  },
  {
    name: "email",
    label: "Email",
    type: "text",
    required: false,
  },
  {
    name: "phoneNumber",
    label: "Τηλέφωνο",
    type: "number",
    required: true,
  },
  {
    name: "mobileNumber",
    label: "Κινητό Τηλέφωνο",
    type: "number",
    required: false,
  },
  {
    name: "memberOfMedicalTeam",
    label: "Μέλος Ιατρικής Ομάδας",
    type: "checkbox",
    required: false,
  },
];

// Δημιουργούμε μια προεπιλεγμένη λίστα (χωρίς options) για να υπάρχει συμβατότητα όπου χρειάζεται
const defaultDoctorFields = doctorFields([]);

export const doctorFilters = defaultDoctorFields
  .filter((f) =>
    ["firstName", "lastName", "amka", "medicalLicenseNumber"].includes(f.name),
  )
  .map((f) => f.name);

export const doctorFormData: string[] = [
  "lastName",
  "firstName",
  "amka",
  "medicalLicenseNumber",
  "specialtyId",
  "email",
  "phoneNumber",
  "mobileNumber",
  "memberOfMedicalTeam",
];
